var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { State, Getter, namespace } from 'vuex-class';
import { UserService } from '~/services/management-service/user.service';
import { DepartmentService } from '~/services/management-service/department.service';
import { Prop } from 'vue-property-decorator';
var systemManageModule = namespace('system-manage');
var AddUser = /** @class */ (function (_super) {
    __extends(AddUser, _super);
    function AddUser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addParams = {
            userEmail: '',
            userLevel: 'C',
            userStatus: 'ENABLED',
            caseSwitch: 'ENABLED',
            userName: '',
            realName: '',
            companyCode: '',
            deptId: '',
            password: '',
            deptType: '',
        };
        _this.typeList = [];
        _this.userDatas = '';
        _this.companyNames = [];
        _this.deptIds = [];
        _this.isIcon = false;
        _this.rules = {
            realName: [
                { required: true, message: '请输入姓名', trigger: 'blur' },
                {
                    message: '请输入汉字或英文字母',
                    trigger: 'blur',
                    pattern: /^([\u4e00-\u9fa5]+|([a-zA-Z]+\s?)+)$/,
                },
            ],
            userName: [
                { required: true, message: '请输入用户名', trigger: 'blur' },
                {
                    message: '用户名只能包含数字、字母、下划线',
                    trigger: 'blur',
                    pattern: /^([A-Za-z0-9_-]+)$/,
                },
                { min: 6, message: '请输入6位以上数字、字母、下划线', trigger: 'blur' },
            ],
            phone: { validator: _this.$validator.phoneNumber, trigger: 'blur' },
            userEmail: [
                { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' },
                { min: 1, max: 50, message: '邮箱长度不能超过50位', trigger: 'blur' },
            ],
        };
        return _this;
    }
    AddUser.prototype.refresh = function (dept) {
        this.addParams.companyCode = dept.companyCode;
        this.addParams.deptType = dept.deptType;
        this.addParams.deptId = dept.id;
        this.addParams.department = dept;
        this.deptIds = [];
        this.getDeptIds(dept.id);
    };
    /**
     * 机构改变
     */
    AddUser.prototype.orgChange = function () {
        if (this.deptIds.length < 1) {
            return;
        }
        var deptId = this.deptIds[this.deptIds.length - 1];
        var deptModel = this.departmentList.find(function (x) { return x.id === deptId; });
        this.addParams.department = deptModel;
        this.addParams.deptType = deptModel.deptType;
    };
    AddUser.prototype.getDeptIds = function (id) {
        var dept = this.departmentList.find(function (x) { return x.id === id; });
        if (dept) {
            this.deptIds.unshift(id);
            if (dept.parentId) {
                this.getDeptIds(dept.parentId);
            }
        }
    };
    /**
     * 新增用户确认
     */
    AddUser.prototype.addUserCommit = function () {
        var _this = this;
        var addForm = this.$refs['add-form'];
        addForm.validate(function (valid) {
            if (!valid)
                return false;
            _this.addParams.password = _this.password;
            _this.userService.createUser(_this.addParams).subscribe(function (data) {
                //   重置form表单xr
                var addForm = _this.$refs['add-form'];
                addForm.resetFields();
                _this.addParams.deptId = '';
                _this.deptIds = [];
                //   关闭dialog
                _this.$emit('close');
                _this.$message.success('新增用户成功!');
                //   刷新databox
                _this.$emit('refresh');
            });
        });
    };
    /**
     * 新增用户取消
     */
    AddUser.prototype.addUserCancel = function () {
        //   重置form表单
        var addForm = this.$refs['add-form'];
        addForm.resetFields();
        this.addParams.deptId = '';
        this.deptIds = [];
        //   关闭dialog
        this.$emit('close');
    };
    __decorate([
        Dependencies(UserService)
    ], AddUser.prototype, "userService", void 0);
    __decorate([
        Dependencies(DepartmentService)
    ], AddUser.prototype, "departmentService", void 0);
    __decorate([
        Prop()
    ], AddUser.prototype, "deptId", void 0);
    __decorate([
        Prop()
    ], AddUser.prototype, "password", void 0);
    __decorate([
        State
    ], AddUser.prototype, "companyList", void 0);
    __decorate([
        State
    ], AddUser.prototype, "departmentList", void 0);
    __decorate([
        systemManageModule.State
    ], AddUser.prototype, "orgInfo", void 0);
    __decorate([
        Getter
    ], AddUser.prototype, "departmentData", void 0);
    __decorate([
        State
    ], AddUser.prototype, "userData", void 0);
    AddUser = __decorate([
        Component({
            components: {},
        })
    ], AddUser);
    return AddUser;
}(Vue));
export default AddUser;
